export const FILTER_EDITOR_LOCALE = {
    // åæ¶
    cancelButton: 'Cancel',
    // ç¡®å®
    okButton: 'OK',
    // æ·»å å­å¥
    addWhere: 'Add',
    clear: 'Clear',
    // ç½®é¡¶
    moveTop: 'Top',
    // ä¸ç§»
    moveUp: 'Up',
    // ä¸ç§»
    moveDown: 'Down',
    // ç½®åº
    moveBottom: 'Bottom',
    // å·¦æ¬å·
    leftBrackets: 'Left Brackets',
    // å­æ®µ
    field: 'Field Name',
    // æä½ç¬¦
    operator: 'Operator',
    // å¼
    value: 'Value',

    valueType: 'Value type',
    expressType: {
        value: 'Value',
        express: 'Expression',
        frontExpress: 'Front Expression'
    },
    // å³æ¬å·
    rightBrackets: 'Right Brackets',
    // å³ç³»
    relation: 'Relation',
    relationValue: {
        and: 'And',
        or: 'Or'
    },

    // è®¾è®¡å¨
    designTab: 'Design',
    // æºä»£ç 
    jsonTab: 'JSON',
    // Sqlé¢è§
    sqlTab: 'Sql',
    title: 'Filter Designer',
    message: 'Are you sure you want to clear all current data?',
    validate: {
        bracket: 'The brackets do not match, please check',
        relation: 'The condition relationship is incomplete, please check',
        field: 'Condition field is not set, please check'
    }
};


export const ENUM_EDITOR_LOCALE = {
    // åæ¶
    cancelButton: 'Cancel',
    // ç¡®å®
    okButton: 'OK',
    // æ·»å å­å¥
    addWhere: 'Add',
    clear: 'Clear',
    // ç½®é¡¶
    moveTop: 'Top',
    // ä¸ç§»
    moveUp: 'Up',
    // ä¸ç§»
    moveDown: 'Down',

    remove: 'Remove',

    // ç½®åº
    moveBottom: 'Bottom',
    title: 'Enum Data Designer',
    message: 'Are you sure you want to clear all current data?',

    value: 'Value',
    name: 'Name'
};
